import { render, staticRenderFns } from "./AppEmailSegmentation.vue?vue&type=template&id=2196508b"
import script from "./AppEmailSegmentation.vue?vue&type=script&lang=ts"
export * from "./AppEmailSegmentation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports